import { FaPlus } from "react-icons/fa";
import { IoIosInformationCircleOutline } from "react-icons/io";

import { PointToken } from "shared/api/use-points-tokens-query";
import WasabiLogo from "shared/assets/wasabi-logo.svg?react";
import { tokensMeta } from "shared/config/tokens";
import { Button } from "shared/ui/button";
import { Img } from "shared/ui/img";
import { Table } from "shared/ui/table";
import { Tooltip } from "shared/ui/tooltip";

type Props = {
  token: PointToken;
};

export const RowMobile = (props: Props) => {
  const { token } = props;
  const meta = tokensMeta[token.symbol];

  return (
    <div className="bg-baltic-sea/30 flex flex-col rounded-[10px] p-3.5">
      <div className="flex items-center gap-x-3.5">
        <Img
          className="size-9 shrink-0"
          src={meta?.logoURI}
          alt={token.symbol}
        />
        <div className="flex flex-col">
          <div className="leading leading-none capitalize">{token.name}</div>
          <div className="text-nobel/70 mt-1 w-50 overflow-hidden text-sm leading-[150%] text-ellipsis whitespace-nowrap capitalize">
            {token.description}
          </div>
        </div>
      </div>

      <Table className="mt-5 gap-y-4">
        <Table.Item
          label={
            <Tooltip>
              <Tooltip.Trigger asChild>
                <button className="flex items-center gap-1.5 outline-hidden">
                  <span>Rewards</span>
                  <IoIosInformationCircleOutline className="text-nobel/50 size-4" />
                </button>
              </Tooltip.Trigger>
              <Tooltip.Content>HARDCODE</Tooltip.Content>
            </Tooltip>
          }
          value={
            <div className="flex items-center gap-x-1.5">
              {token.multiplier}x
              <div className="bg-spearmint flex size-5 items-center justify-center rounded-full">
                <WasabiLogo className="inline-flex size-4 text-black" />
              </div>
            </div>
          }
        />
      </Table>

      <Button className="mt-5 w-full" variant="spearmint/10">
        <FaPlus className="size-3" /> Deposit
      </Button>
    </div>
  );
};
